import React from 'react'
import { ErrorBoundary } from 'react-error-boundary'
import { useDispatch } from 'react-redux'
import * as R from 'ramda'

import { renderCardFailure } from '~/store/actions/timeline'
import type { TimelineItem } from '~/types'

import LoadingCard from './LoadingCard'
import TimelineErrorCard from './TimelineErrorCard'
import useTimelineItems from './timelineItems'

export interface TimelineTableRowProps {
  clientId: string
  expanded?: boolean
  index: number
  isItemLoaded: (index: number) => boolean
  item?: TimelineItem | null
  patientId: string
}
const TimelineTableRow = ({
  clientId,
  patientId,
  item,
  expanded,
  index,
  isItemLoaded,
}: TimelineTableRowProps) => {
  const dispatch = useDispatch()

  const timelineItems = useTimelineItems()
  const timelineItemKey = [item?.type, item?.subType]
    .filter(Boolean)
    .join('.')
    .toLowerCase()

  const timelineItem = timelineItems[timelineItemKey] || {}

  const { icon, permission, component: Card } = timelineItem

  const logError = (error: Error, info: { componentStack: string }) => {
    dispatch(renderCardFailure(error, info))
  }
  const isCharheSheet = R.pathEq(['invoice', 'posted'], false, item)

  if (item === null) {
    return null
  }

  const isLoading = !isItemLoaded(index) || !item || R.isEmpty(item) || !Card

  if (!isLoading && !permission) {
    return null
  }

  return isLoading ? (
    <LoadingCard />
  ) : (
    <ErrorBoundary
      // eslint-disable-next-line react/no-unstable-nested-components
      FallbackComponent={() => (
        <TimelineErrorCard date={item.date} icon={icon} />
      )}
      onError={logError}
    >
      <Card
        clientId={clientId}
        expanded={expanded}
        icon={icon}
        index={index}
        isInvoice={!isCharheSheet}
        item={item}
        patientId={patientId}
      />
    </ErrorBoundary>
  )
}

export default TimelineTableRow
